import React from 'react';
import FormGroup from './FormGroup';
import './Select.css';

const Select = ({
  label,
  helpText,
  error,
  required,
  optional,
  block,
  options = [],
  placeholder,
  className = '',
  children,
  ...props
}) => {
  return (
    <FormGroup label={label} helpText={helpText} error={error} required={required} optional={optional} block={block}>
      <select
        className={`p-select ${className}`}
        required={required}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.length > 0
          ? options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))
          : children}
      </select>
    </FormGroup>
  );
};

export default Select;
